const { transferStatus: transferStatusEnum, transferPaymentMethod } = require('@transfeeradev/api-enums');
const dbaBankAccountDataFields = ['name', 'cpf_cnpj', 'bank_id', 'account_type', 'agency', 'account', 'account_digit'];

class TransferPixService {
  static isPixByTransfer(payment_method, dba) {
    const isPixDba = this.isPix(dba);
    return isPixDba || payment_method === transferPaymentMethod.PIX;
  }

  static isPix(dba) {
    return (
      dba &&
      typeof dba.pix_key_type !== 'undefined' &&
      dba.pix_key_type !== null &&
      typeof dba.pix_key !== 'undefined' &&
      dba.pix_key !== null
    );
  }

  static hasCompleteBankAccountData(dba) {
    return dba && dbaBankAccountDataFields.every(field => typeof dba[field] !== 'undefined' && dba[field] !== null);
  }

  static isTransferred(transferStatus, dba) {
    const isPix = TransferPixService.isPix(dba);

    return (
      (isPix && transferStatus === transferStatusEnum.FINISHED) ||
      (!isPix && transferStatus === transferStatusEnum.TRANSFERRED)
    );
  }
}

module.exports = TransferPixService;
